import {
  Inicio,
  AcercaDeNosotros,
  Contacto,
  Agenda,
  Error404,
  DesarrolladoPor,
} from "../pages";
import { UserLayout, BasicLayout } from "../layouts";

// LISTADO DE LAS URL PARA EL USUARIO ADMINISTRADOR
const routes = [
  {
    path: "/",
    layout: UserLayout,
    component: Inicio,
    exact: true,
  },
  {
    path: "/acercade",
    layout: UserLayout,
    component: AcercaDeNosotros,
    exact: true,
  },
  {
    path: "/contacto",
    layout: UserLayout,
    component: Contacto,
    exact: true,
  },
  {
    path: "/agenda",
    layout: UserLayout,
    component: Agenda,
    exact: true,
  },
  {
    path: "/desarrolladores",
    layout: UserLayout,
    component: DesarrolladoPor,
    exact: true,
  },
  {
    path: "*",
    layout: BasicLayout,
    component: Error404,
  },
];

export default routes;
